import { IAppDetails } from './types';

export type ISetAppDetails = ReturnType<typeof setAppDetails>;
export const setAppDetails = (appDetails: IAppDetails) => ({
  type: 'organisation/set-app-details' as const,
  payload: { appDetails },
});
